module.exports = __webpack_public_path__ + "static/media/icon_header.9d660258.png";